<div class="modal-dialog checkout-dialog" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">
        {{'الدفع' | translate}}
      </h4>
      <button type="button" class="close" aria-label="Close" mat-dialog-close>
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body checkout-dialog-body" id="formModalBody" *ngIf="PaymentObj">
      <!-- <div class="selected-plan selected-course">
        <div class="lable"> {{"pricing.selectedCourse"|translate}}</div>
        <div class="plan-card">
          <div class="text center-name">
            {{data.centerName}}
          </div>
          <div class="plan-name">{{data.title}}</div>
          <div class="text" *ngIf="data.catgoryName">
            {{data.catgoryName}}
          </div>
          <div class="price-duration">
            <div class="price">{{data.pricing}}<span class="currency">SAR</span></div>
          </div>
        </div>
      </div> -->
      <app-payment-card-form [paymentObj]="PaymentObj"></app-payment-card-form>
    </div>
  </div>
</div>
